import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SharedModule } from '../../../shared/shared.module';
import { GeoRegionSelectorComponent } from '../../../shared/geo-region-selector/geo-region-selector.component';
import { ConfigGeoRegions } from '../../../../config/geo-regions';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Organization } from '../../../../models/entities/organization';
import { OrganizationService } from '../../../../services/organization/organization.service';
import { GrowlerService } from '../../../shared/growler/growler.service';
import { GenericDialogResult } from '../generic-mat-dialog/generic-dialog-result';

export interface OrgAddressDialogInput
{
    organization: Organization;
}

@Component({
    selector: 'app-org-address-dialog',
    templateUrl: './org-address-dialog.component.html',
    styleUrls: ['./org-address-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        SharedModule,
        GeoRegionSelectorComponent,
    ],
})
export class OrgAddressDialogComponent implements OnInit
{
    orgModel: UntypedFormGroup;
    organization: Organization;
    isSubmitting = false;
    errorMessage = 'This field is required.';

    constructor(
            private _builder: UntypedFormBuilder,
            private _dialogRef: MatDialogRef<OrgAddressDialogComponent>,
            private _growler: GrowlerService,
            private _organizationService: OrganizationService,
            @Inject(MAT_DIALOG_DATA) public data: OrgAddressDialogInput,
    ) {
    }

    ngOnInit(): void {
        this.organization = this.data.organization;
        this.buildOrgModel();
    }

    buildOrgModel() {
        this.orgModel = this._builder.group({
            address1: [
                this.organization.profile.address1 || [''],
                Validators.required,
            ],
            address2: [this.organization.profile.address2 || ['']],
            city: [this.organization.profile.city || ['']],
            region: [
                [
                    ConfigGeoRegions.findRegion({
                        countryCode: 'US',
                        region: this.organization.profile.state,
                    }),
                ] || [null],
                Validators.required,
            ],
            zip: [
                this.organization.profile.zip || [''],
                Validators.required,
            ],
        });
    }

    isFieldInvalid(fieldName: string): boolean {
        return this.orgModel.get(fieldName).touched && !this.orgModel.get(fieldName).value;
    }

    onSubmit(): void {
        if (this.isSubmitting) {
            return;
        }

        this.orgModel.markAllAsTouched();
        if (!this.orgModel.valid) {
            this._growler.error(
                    'Oops!',
                    'Please double-check required fields.',
            );
            return;
        }

        this.isSubmitting = true;
        const data = this.orgModel.getRawValue();
        const requestBody = {
            address1: data.address1,
            address2: data.address2,
            city: data.city,
            zip: data.zip,
        };
        if (data.region !== null) {
            requestBody['state'] = data.region.region;
            requestBody['country'] = data.region.countryCode;
        }

        this._organizationService.updateOrganization(null, requestBody).subscribe(
                () => {
                    this._growler.success(
                            'Saved!',
                            'Your organization address has been updated.',
                    );
                    this._dialogRef.close(<GenericDialogResult>{success: true});
                },
                () => {
                    this._dialogRef.close();
                    this._growler.error(
                            'Oops!',
                            'There was a problem updating your organization address.',
                    );
                },
        );
    }


}
